import { APIClient } from '@frontend/api-utils';
import { FirebaseNotification } from '@frontend/push-notification/types';

export class FirebaseClient extends APIClient {
    public static readonly endpoint = '/push-notification-api/v1';

    public static async postCreateNotification(accountId: string, userId: string, firebaseNotification: FirebaseNotification): Promise<void> {
        const repsonse = await this.post(`${this.endpoint}/accounts/${accountId}/users/${userId}/notifications`, firebaseNotification);
        return this.handleVoidResponse(repsonse);
    }
}
